import { render, staticRenderFns } from "./HomeVeranstalter.vue?vue&type=template&id=ba19adda"
import script from "./HomeVeranstalter.vue?vue&type=script&lang=ts"
export * from "./HomeVeranstalter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports